import {MenuProps} from "antd";

export const STATUS_OPTIONS: MenuProps['items'] = [
    {key: 'READ', label: 'Read'},
    {key: 'DELIVERED', label: 'Delivered'},
    {key: 'SENT', label: 'Sent'},
    {key: 'FAILED', label: 'Failed'},
    {key: 'UNDELIVERED', label: 'Undelivered'},
    {key: 'IN PROCESS', label: 'In Process'},
]